import { toast } from "react-toastify";
import { fetchAddUomSuccess, fetchAddUomFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { ADD_UOM_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

export const addUnitOfMeasurement = (jsonObj, setLoading, navigate,triggerRefresh,toggle) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${ADD_UOM_API}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            toggle()        
            setLoading(false)
            triggerRefresh()
            dispatch(fetchAddUomSuccess(response))
            dispatch(setSuccessMessage(true))
           
        }
        if (response.error) {
            dispatch(fetchAddUomFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}